// Copyright 2026, University of Maryland, All Rights Reserved
import { forwardRef, type ComponentPropsWithoutRef } from 'react'
import { Loader2 } from 'lucide-react'
import { Button } from '@/components/ui'

export type SubmitButtonProps = ComponentPropsWithoutRef<typeof Button> & {
  loading?: boolean
}

export const SubmitButton = forwardRef<HTMLButtonElement, SubmitButtonProps>(
  ({ loading = false, children, disabled, ...props }, ref) => (
    <Button ref={ref} disabled={disabled || loading} {...props}>
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : children}
    </Button>
  ),
)
SubmitButton.displayName = 'SubmitButton'
